/**
 * 工具类
 */
//  import Vue from 'vue'
 import CryptoJS from 'crypto-js'

var key = CryptoJS.enc.Utf8.parse("nRbzhiS7uVDjiauG");//密钥
var iv = CryptoJS.enc.Utf8.parse('n3FwUJ7Y2UADqsXN');//偏移iv
 
 //加密
 export function encrypt(word){ 
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
 }
  
 //解密
 export function decrypt(word){  
   var srcs = word;
   var decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
   var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
   var value = decryptedStr.toString();
   return value;
 }